export const RENDERER_COLOR = "#262837";
export const FOG_COLOR = "#262837";
export const FOG_NEAR = 1;
export const FOG_FAR = 5;
